export type { Locale } from '@/i18n'

/**
 * Remove locale prefix from a path
 * Examples: /tr/cases -> /cases, /es -> /, /profile -> /profile
 */
export function removeLocalePrefix(path: string): string {
  return path.replace(/^\/(tr|es|ru|pl|de|ro)/, '') || '/'
}

/**
 * Add locale prefix to a path
 * English uses base URL (no prefix), others get /tr, /es, /ru, /pl, /de, /ro
 * Examples:
 *   (en, /cases) -> /cases
 *   (tr, /cases) -> /tr/cases
 *   (es, /) -> /es
 */
export function addLocalePrefix(locale: string, path: string): string {
  // First, always remove any existing locale prefix
  const cleanPath = removeLocalePrefix(path)

  if (locale === 'en') {
    return cleanPath
  }

  return `/${locale}${cleanPath === '/' ? '' : cleanPath}`
}

/**
 * Extract locale from path
 * Returns the locale if present in path, otherwise null
 * Examples: /tr/cases -> 'tr', /cases -> null, /es -> 'es'
 */
export function extractLocaleFromPath(path: string): string | null {
  const match = path.match(/^\/(tr|es|ru|pl|de|ro)/)
  return match ? match[1] : null
}
